import { render, staticRenderFns } from "./RequestButton.vue?vue&type=template&id=5e461b4c&scoped=true&"
import script from "./RequestButton.vue?vue&type=script&lang=ts&"
export * from "./RequestButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e461b4c",
  null
  
)

export default component.exports